import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'
import errorLog from './modules/errorLog'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    permission,
    errorLog
  },
  getters
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js